import React, { useEffect, useState, useCallback } from 'react'
import { getLogsData, getServersData } from '../../actions/dashboard'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/Loader'
import Table from '../../components/Table'
import TableSearch from '../../components/TableSearch'
import moment from 'moment'
import styles from './styles.module.scss'

const Backup = () => {

  const dispatch = useDispatch()
  const { servers, loading } = useSelector(state => state.dashboard)
  const [filteredData, setFilteredData] = useState(null)
  const [sortState, setSortState] = useState({ key: null, order: null })
  const [openSearchKey, setOpenSearchKey] = useState(null)

  useEffect(() => {
    dispatch(getServersData())
  }, [])

  const handleFilter = useCallback((result, query) => {
    if (!query) {
      setFilteredData(null)
      return
    }
    setFilteredData(result || [])
  }, [])

  const handleSearchOpen = useCallback((searchKey) => {
    setOpenSearchKey(searchKey)
  }, [])

  const handleSort = useCallback((sortedData, sortKey, sortOrder) => {
    setSortState({ key: sortOrder ? sortKey : null, order: sortOrder })
  }, [])

  // Комбинируем фильтрацию и сортировку
  const dataNew = React.useMemo(() => {
    let data = filteredData ?? servers

    // Сортировка первичного массива по алфавиту (если нет активной сортировки)
    if (!sortState.order || !sortState.key) {
      if (data && data.length > 0) {
        data = [...data].sort((a, b) => {
          const aName = String(a?.name || '').toLowerCase().trim()
          const bName = String(b?.name || '').toLowerCase().trim()
          return aName.localeCompare(bName, 'ru', { numeric: true })
        })
      }
    }

    if (sortState.order && sortState.key) {
      // Если есть активная сортировка, применяем её к текущим данным
      const sorted = data && [...data]?.sort((a, b) => {
        const aValue = a?.[sortState.key]
        const bValue = b?.[sortState.key]

        if (aValue === null || aValue === undefined) return 1
        if (bValue === null || bValue === undefined) return -1

        if (typeof aValue === 'number' && typeof bValue === 'number') {
          return sortState.order === 'asc' ? aValue - bValue : bValue - aValue
        }

        const aStr = String(aValue).toLowerCase()
        const bStr = String(bValue).toLowerCase()

        if (sortState.order === 'asc') {
          return aStr.localeCompare(bStr, 'ru', { numeric: true })
        } else {
          return bStr.localeCompare(aStr, 'ru', { numeric: true })
        }
      })
      return sorted
    }

    return data
  }, [filteredData, servers, sortState])

  const dataToRender = dataNew?.filter(el => !el.archive)

  if (loading) return <Loader />;

  const formattedDate = (date) => date ? moment(date).format('DD.MM.YYYY HH:mm:ss') : '';

  const isBackupOverdue = (date) => {
    if (!date) return false
    const mDate = moment(date)
    if (!mDate.isValid()) return false
    return moment().diff(mDate, 'days') > 2
  }

  const renderLog = (item) => {
    const overdue = isBackupOverdue(item.lastbackup_date)
    const hasRecentBackup = item.lastbackup_date && moment(item.lastbackup_date).isValid() && !overdue
    const dateCellClass = overdue ? styles.backupOverdue : hasRecentBackup ? styles.backupRecent : ''

    return (
      <tr key={item.id}>
        <td>{item.name}</td>
        <td>{item.hostglobal}</td>
        <td className={dateCellClass}>{formattedDate(item.lastbackup_date)}</td>

        <td>{item.lastbackup_size}</td>
      </tr>
    )
  }

  return (
    <section>
      <Table maxHeight='86vh' minHeight='500px' dataLoaded={!loading && servers?.length > 0}>
        <thead>
          <tr>
            <th>
              <div className={styles.headerCellWrapper}>
                <div>Наименование</div>
                <div>
                  <TableSearch
                    data={servers}
                    searchKey="name"
                    onFilter={handleFilter}
                    onSort={handleSort}
                    activeSortKey={sortState.key}
                    activeSortOrder={sortState.order}
                    onSearchOpen={handleSearchOpen}
                    openSearchKey={openSearchKey}
                  />
                </div>
              </div>
            </th>
            <th>
              <div className={styles.headerCellWrapper} style={{ width: '150px' }}>
                <div>Сервер</div>
                <div>
                  <TableSearch
                    data={servers}
                    searchKey="hostglobal"
                    onFilter={handleFilter}
                    onSort={handleSort}
                    activeSortKey={sortState.key}
                    activeSortOrder={sortState.order}
                    onSearchOpen={handleSearchOpen}
                    openSearchKey={openSearchKey}
                  />
                </div>
              </div>
            </th>
            <th>
              <div className={styles.headerCellWrapper} style={{ width: '150px' }}>
                <div>Бэкап дата</div>
                <div>
                  <TableSearch
                    data={servers}
                    searchKey="lastbackup_date"
                    onFilter={handleFilter}
                    onSort={handleSort}
                    activeSortKey={sortState.key}
                    activeSortOrder={sortState.order}
                    onSearchOpen={handleSearchOpen}
                    openSearchKey={openSearchKey}
                  />
                </div>
              </div>
            </th>
            <th>
              <div className={styles.headerCellWrapper} style={{ width: '130px' }}>
                <div>Бэкап размер</div>
                <div>
                  <TableSearch
                    data={servers}
                    searchKey="lastbackup_size"
                    onFilter={handleFilter}
                    onSort={handleSort}
                    activeSortKey={sortState.key}
                    activeSortOrder={sortState.order}
                    onSearchOpen={handleSearchOpen}
                    openSearchKey={openSearchKey}
                  />
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {dataToRender?.map(renderLog)}
        </tbody>
      </Table>
    </section>
  )
}

export default Backup